import React, { useState } from 'react';
import { SUGGESTED_CATEGORIES } from './skillsUtils';

const inputStyle = {
  width: '100%',
  padding: '9px 12px',
  background: 'var(--surface-1)',
  border: '1px solid var(--card-border)',
  borderRadius: '8px',
  color: 'var(--text-primary)',
  fontSize: '13px',
  outline: 'none',
  transition: 'border-color 0.15s ease',
  boxSizing: 'border-box',
};

/**
 * AddCategoryPanel — shown when the user clicks "Add Skill Category".
 * Offers quick-pick suggested names and a free-text input.
 */
export default function AddCategoryPanel({ existing, onAdd, onClose }) {
  const [customName, setCustomName] = useState('');
  const existingNames = new Set(existing.map(c => c.name.toLowerCase()));

  const handleAdd = (name) => {
    const trimmed = name.trim();
    if (!trimmed) return;
    onAdd(trimmed);
    onClose();
  };

  return (
    <div style={{
      background: 'var(--surface-1)',
      border: '1px solid var(--brand-border)',
      borderRadius: '10px',
      padding: '14px',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
    }}>
      <span style={{
        fontFamily: "'Outfit', sans-serif",
        fontSize: '11px',
        fontWeight: 700,
        letterSpacing: '0.5px',
        textTransform: 'uppercase',
        color: 'var(--text-secondary)',
      }}>
        Choose or type a category name
      </span>

      {/* Quick-pick suggestion chips */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
        {SUGGESTED_CATEGORIES
          .filter(s => !existingNames.has(s.toLowerCase()))
          .map(s => (
            <button
              key={s}
              onClick={() => handleAdd(s)}
              style={{
                padding: '4px 10px',
                background: 'var(--surface-0)',
                border: '1px solid var(--card-border)',
                borderRadius: '14px',
                fontSize: '11px',
                fontWeight: 600,
                color: 'var(--text-secondary)',
                cursor: 'pointer',
                transition: 'border-color 0.15s, color 0.15s',
              }}
            >
              + {s}
            </button>
          ))}
      </div>

      {/* Custom name input */}
      <div style={{ display: 'flex', gap: '8px' }}>
        <input
          autoFocus
          type="text"
          value={customName}
          onChange={e => setCustomName(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') handleAdd(customName);
            if (e.key === 'Escape') onClose();
          }}
          placeholder="Or type a custom name…"
          style={{ ...inputStyle, flex: 1, fontSize: '12px' }}
        />
        <button
          onClick={() => handleAdd(customName)}
          disabled={!customName.trim()}
          style={{
            padding: '0 14px',
            background: 'var(--brand)',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '12px',
            fontWeight: 700,
            cursor: customName.trim() ? 'pointer' : 'not-allowed',
            opacity: customName.trim() ? 1 : 0.5,
            whiteSpace: 'nowrap',
          }}
        >
          Add
        </button>
        <button
          onClick={onClose}
          style={{
            background: 'transparent',
            border: '1px solid var(--card-border)',
            padding: '6px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            color: 'var(--text-muted)',
            cursor: 'pointer',
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
